import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Card } from '@grandvisionhq/common';
import { LineItemSlotsProvider, LineItemCard, PrescriptionTable, LineItemModels, GlassesPrescription } from '@grandvisionhq/lib-visuals';
import StoreDetailModal from '../../Appointments/components/StoreDetailModal/StoreDetailModal.js';
import { useAddressFormSlotsContext } from '../../slots/AddressFormSlotsContext.js';
import { useStoreAddressFormSlotsContext } from '../../slots/StoreAddressFormSlotsContext.js';
import DetailFooterContainer from '../components/Footer/DetailFooter/DetailFooterContainer.js';
import Order from '../components/Order/Order.js';
import Reorder from '../components/Reorder/Reorder.js';
import { isContactLensesOrderLineItem } from '../models/line-items.js';

const OrderDetail = ({ labels , onCloseStoreDetailModal , onOpenStoreDetailModal , onTraceOrder , onReorder , onOpenCancelReturnsModal , onCloseCancelReturnsModal , onDownloadReceiptClick , isCancelReturnsModalOpen , detail , isModalOpen , storeName , intl , prescriptionsUrl , isReorderAvailable , isPaid ,  })=>{
    var ref, ref1;
    const { Slots: { summary: AddressSummaryTemplate  } ,  } = useAddressFormSlotsContext();
    const { Slots: { summary: StoreAddressSummaryTemplate  } ,  } = useStoreAddressFormSlotsContext();
    return /*#__PURE__*/ React.createElement("div", {
        className: "order-detail"
    }, /*#__PURE__*/ React.createElement(Order, {
        className: "order-details__order",
        onReorder: isReorderAvailable ? onReorder : undefined,
        shipmentTrackingUrl: detail.shipmentTrackingUrl,
        footer: /*#__PURE__*/ React.createElement(DetailFooterContainer, {
            subtotal: detail.subtotalAmount,
            discount: detail.discountedAmount,
            shippingCost: detail.shippingMethodPrice,
            total: detail.totalPrice
        }),
        orderDate: detail.orderDate,
        orderNumber: detail.orderNumber,
        shipmentStatus: detail.shipmentStatus,
        receiptUrl: detail.receiptUrl,
        paymentStatus: detail.paymentStatus,
        onTraceOrder: onTraceOrder,
        onOpenCancelReturnsModal: onOpenCancelReturnsModal,
        onCloseCancelReturnsModal: onCloseCancelReturnsModal,
        onDownloadReceiptClick: onDownloadReceiptClick,
        isCancelReturnsModalOpen: isCancelReturnsModalOpen,
        isPaid: isPaid
    }, detail === null || detail === void 0 ? void 0 : (ref = detail.lineItems) === null || ref === void 0 ? void 0 : ref.map((item, i)=>{
        const lineItemCardProps = {
            currency: intl.currency,
            discountPrice: item.discountPrice,
            imagePath: item.imageUrl,
            labels: {
                prescription: labels.prescription,
                configuration: labels.configuration
            },
            lineItemId: item.lineItemId,
            price: item.price,
            quantity: item.quantity,
            subtitle: item.subtitle,
            title: item.title
        };
        if ('bundleChildLineItems' in item) {
            lineItemCardProps.bundleChildLineItems = item.bundleChildLineItems;
        }
        const LineItemCardSlot = {
            Reorder: ()=>/*#__PURE__*/ React.createElement(Reorder, {
                    id: item.lineItemId,
                    isReorderAvailable: Boolean(item.isReorderAvailable),
                    onReorder: onReorder
                })
        };
        if (isContactLensesOrderLineItem(item)) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(LineItemSlotsProvider, {
                slots: LineItemCardSlot
            }, /*#__PURE__*/ React.createElement(LineItemCard, swcHelpers.extends({
                key: `${item.sku}-${i}`
            }, lineItemCardProps), item.prescription ? /*#__PURE__*/ React.createElement(LineItemCard.PrescriptionSection, {
                labels: lineItemCardProps.labels
            }, /*#__PURE__*/ React.createElement(PrescriptionTable, {
                size: "narrow",
                orientation: "eyeSideTop",
                prescription: swcHelpers.objectSpread({}, item.prescription),
                formatPrescription: true
            })) : null)));
        }
        if ('prescription' in item && item.prescription) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(LineItemSlotsProvider, {
                slots: LineItemCardSlot
            }, /*#__PURE__*/ React.createElement(LineItemCard, swcHelpers.extends({
                key: `${item.sku}-${i}`
            }, lineItemCardProps), /*#__PURE__*/ React.createElement(LineItemCard.PrescriptionSection, {
                labels: lineItemCardProps.labels
            }, LineItemModels.isGlassesBundleLineItem(item) ? /*#__PURE__*/ React.createElement(GlassesPrescription, {
                prescriptionsUrl: prescriptionsUrl,
                intl: intl,
                prescription: item.prescription
            }) : /*#__PURE__*/ React.createElement(PrescriptionTable, {
                size: "narrow",
                orientation: "eyeSideTop",
                formatPrescription: true,
                prescription: swcHelpers.objectSpread({}, item.prescription)
            })))));
        }
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(LineItemSlotsProvider, {
            slots: LineItemCardSlot
        }, /*#__PURE__*/ React.createElement(LineItemCard, swcHelpers.extends({
            key: `${item.sku}-${i}`
        }, lineItemCardProps))));
    })), /*#__PURE__*/ React.createElement(Card.Section, {
        className: "order-details__info"
    }, /*#__PURE__*/ React.createElement(Card.Heading, {
        variant: "smallest"
    }, labels.orderDetails)), /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, labels.shipmentMethodTitle), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement(Card.Text, null, labels.makeDeliveryMethodName(detail === null || detail === void 0 ? void 0 : detail.shippingInfo)), // if shippingInfo is 'pick-up' then show store-info card
    (detail === null || detail === void 0 ? void 0 : detail.shippingInfo) === 'pick-up' && /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(Card.Link, {
        iconAfter: "chevron-right",
        onClick: onOpenStoreDetailModal
    }, labels.storeInfo))))), /*#__PURE__*/ React.createElement(Card.Section, null, (detail === null || detail === void 0 ? void 0 : (ref1 = detail.shippingAddress) === null || ref1 === void 0 ? void 0 : ref1.externalId) && isModalOpen && /*#__PURE__*/ React.createElement(StoreDetailModal, {
        storeCode: detail.shippingAddress.externalId,
        onModalClose: onCloseStoreDetailModal
    }), /*#__PURE__*/ React.createElement(Card.Section, {
        flex: true,
        className: "order-details__items"
    }, /*#__PURE__*/ React.createElement(Card.Section, {
        className: "order-details__detail",
        spacing: "none"
    }, detail.shippingAddress && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, labels.shipmentAddress), // if shippingInfo is 'pick-up' then show store-info card
    (detail === null || detail === void 0 ? void 0 : detail.shippingInfo) === 'pick-up' && StoreAddressSummaryTemplate ? /*#__PURE__*/ React.createElement(StoreAddressSummaryTemplate, {
        storeName: storeName,
        values: swcHelpers.objectSpread({}, detail.shippingAddress)
    }) : null, (detail === null || detail === void 0 ? void 0 : detail.shippingInfo) !== 'pick-up' && AddressSummaryTemplate ? /*#__PURE__*/ React.createElement(AddressSummaryTemplate, {
        values: swcHelpers.objectSpread({}, detail.shippingAddress)
    }) : null)), detail.billingAddress && /*#__PURE__*/ React.createElement(Card.Section, {
        className: "order-details__detail",
        spacing: "none"
    }, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, labels.billingAddress), AddressSummaryTemplate ? /*#__PURE__*/ React.createElement(AddressSummaryTemplate, {
        values: swcHelpers.objectSpread({}, detail.billingAddress)
    }) : null)), /*#__PURE__*/ React.createElement(Card.Section, null, detail.paymentMethod && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, labels.paymentMethod), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement(Card.Text, null, detail.paymentMethod)))))));
};
var OrderDetail$1 = OrderDetail;

export { OrderDetail$1 as default };
//# sourceMappingURL=OrderDetail.js.map
